import { t } from "@redotech/redo-i18n";
import { Step as ModelStep } from "@redotech/redo-return-core-common/return-flow";
import { merchantReviewBeforeFilingFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  isMerchantReviewBeforeFilingStepValid,
  MerchantReviewBeforeFilingState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import ShieldCheckIcon from "@redotech/redo-web/icon-old/shield-check.svg";
import { produce } from "immer";
import * as React from "react";
import { StepDownstream, StepType, StepTypeDetailsProps } from "../step";

export const MERCHANT_REVIEW_BEFORE_FILING = (
  Details: React.ComponentType<
    StepTypeDetailsProps<MerchantReviewBeforeFilingState>
  >,
): StepType<
  MerchantReviewBeforeFilingState,
  ModelStep.MerchantReviewBeforeFiling
> => ({
  Details: (props: StepTypeDetailsProps<MerchantReviewBeforeFilingState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  title: STEP_TYPE_NAMES[ModelStep.MERCHANT_REVIEW_BEFORE_FILING],
  valid(state) {
    return isMerchantReviewBeforeFilingStepValid(state).valid;
  },
  Icon: ShieldCheckIcon,
  iconColor: "success",
  description() {
    return t(
      "Hold Package Protection Plus claims for your review before filing",
    );
  },
  downstream(state) {
    const result: StepDownstream[] = [];
    if (state.next !== undefined) {
      result.push({ id: state.next });
    }
    return result;
  },
  maxDownstream() {
    return 1;
  },
  empty: { next: undefined },
  stepDeleted(state, stepId) {
    return produce(state, (state) => {
      if (state.next === stepId) {
        state.next = undefined;
      }
    });
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(
        `Invalid handle index ${handleIndex} for Review before filing step`,
      );
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  layout() {
    return BlockLayout.FULL;
  },
  toModel(state, id) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.MERCHANT_REVIEW_BEFORE_FILING,
      next: state.next ? id(state.next) : undefined,
    };
  },
  fromModel(model, id) {
    return merchantReviewBeforeFilingFromModel(model, id);
  },
});
